import Component from '../../../../js/assets/component.js'

class TourList extends Component {
  constructor(selector){
    super(selector)
  }

  data(){
    return {
      "listType": null
    }
  }

  changed(){
    return {
      "listType": (type)=>{
        this.switchListView(type)
        this.switchButtonView(type)
      }
    }
  }

  activate(){
    this.$el.addClass("-active")
  }

  inActivate(){
    this.$el.removeClass("-active")
  }

  switchButtonView(type){
    switch(type){
      case "small":
        this.$buttonSmall.addClass("-active")
        this.$buttonFull.removeClass("-active")
        break
      case "full":
        this.$buttonSmall.removeClass("-active")
        this.$buttonFull.addClass("-active")
        break
    }
  }

  switchListView(type){
    switch(type){
      case "small":
        this.$tourListSmall.addClass("-active")
        this.$tourListFull.removeClass("-active")
        break
      case "full":
        this.$tourListSmall.removeClass("-active")
        this.$tourListFull.addClass("-active")
        break
    }
  }

  mounted(){
    this.$buttonSmall = this.$el.find(".buttonListSmall")
    this.$buttonFull = this.$el.find(".buttonListFull")
    this.$tourListSmall = this.$el.find(".tourListSmall")
    this.$tourListFull = this.$el.find(".tourListFull")

    this.$buttonSmall.on("click", ()=>{
      this.$data.listType = "small"
    })
    this.$buttonFull.on("click", ()=>{
      this.$data.listType = "full"
    })
  }
}

export default TourList
